// extracted by mini-css-extract-plugin
export default {"hideTooltip":"Zta-z","fadeIn":"_ta-z","delay":"aua-z","recommendedSizeTooltip":"bua-z"};